import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { PolicyQueryService } from './policy-query.service';
import { AdminUserService } from 'src/app/services/admin-user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private authenticatedSource = new BehaviorSubject<boolean>(false);
  authenticated = this.authenticatedSource.asObservable();

  private loggedInUserSource = new BehaviorSubject<string>("");
  loggedInUser = this.loggedInUserSource.asObservable();

  private expiredSource = new BehaviorSubject<boolean>(false);
  expired = this.expiredSource.asObservable();

  constructor(
    private http: HttpClient,
    private oauthService: OAuthService,
    @Inject('BASE_URL') private baseUrl: string,
    private policyQueryService: PolicyQueryService,
    private adminUserService: AdminUserService
  ) {
    if (!!this.oauthService.getAccessToken() && localStorage.getItem('loggedInUser') != null) {
      this.authenticatedSource.next(true);
      // The session is active - see if we have the user still
      this.loggedInUserSource.next(localStorage.getItem('loggedInUser'));
    } else {
      this.adminUserService.changeIsAdmin(null);
      this.oauthService.logOut();
      this.authenticatedSource.next(false);
      this.loggedInUserSource.next(null);
      localStorage.removeItem('loggedInUser');
      this.policyQueryService.changePolicyQuery(null);
    }
  }

  async login(userName: string, password: string): Promise<LoginResult> {
    //for some reason the OID library transmutes null and undefined into the *string* "null" and "undefined".
    //so catch that here before we proceed.
    if (userName === null || userName === undefined || password === null || password === undefined) {
      return { success: false, failureMessage: "Username and Password are required" } as LoginResult;
    }

    //https://github.com/manfredsteyer/angular-oauth2-oidc/blob/master/docs-src/password-flow.md
    try {
      var loggedInUser = userName.replace(RegExp(/(@.*)|(.*\\)/, "g"), "");
      let token = await this.oauthService.fetchTokenUsingPasswordFlow(loggedInUser, password);
      console.log('login check isadmin: ');
      this.adminUserService.isadmin();
      this.authenticatedSource.next(true);
      this.loggedInUserSource.next(loggedInUser);
      // store the user in case browser refreshed
      localStorage.setItem('loggedInUser', loggedInUser);

      return { success: true, failureMessage: null } as LoginResult;

    }
    catch (err) {
      this.authenticatedSource.next(false);
      this.loggedInUserSource.next(null);
      localStorage.removeItem('loggedInUser');

      //add alert to avoid wasting development time - the logged error is unclear ("TypeError: Cannot read property 'toLowerCase' of null")
      if (false === this.baseUrl.startsWith("https")) {
        alert("You must enable SSL for login functionality to work - see README.md");
      }

      let message: string;

      if (err.error && err.error.errorDescription !== undefined) {
        message = err.error.errorDescription;
      }
      else {
        console.error(err);
        message = "An unexpected error occurred.";
      }

      return { success: false, failureMessage: message } as LoginResult;
    }
  }

  logout() {
    this.adminUserService.changeIsAdmin(null);
    this.oauthService.logOut();
    this.authenticatedSource.next(false);
    this.loggedInUserSource.next(null);
    localStorage.removeItem('loggedInUser');
    this.policyQueryService.changePolicyQuery(null);
    this.http.get(`${this.baseUrl}api/identity/logout`, { observe: 'response' }).subscribe(
      response => {
        if (response.status === 200) {
          //
        }
      },
      errorResponse => {
        var errors = errorResponse.error.errors;
        console.log('logout error: ' + errors);
      }
    );
  }

  changeAuthenticated(authenticated: boolean) {
    this.authenticatedSource.next(authenticated);
  }

  changeExpired(expired: boolean) {
    this.expiredSource.next(expired);
  }
}

interface LoginResult {
  success: boolean,
  failureMessage: string
}

interface LoginModelApi {
  email: string,
  password: string
}
